import { Button, Form, Input, Typography } from 'antd';

import type { FC } from 'react';

const { Text } = Typography;
const { Item, useForm } = Form;

export interface PasswordFormProps {
  isSending: boolean;
  onSubmit(password: string): void;
}

interface PasswordFormValues {
  password?: string;
}

/**
 * Шаг «Пароль двухэтапной аутентификации» — общий для Telegram личного и
 * MAX (task/10730). Появляется, когда шаг входа приходит pending_password.
 */
export const PasswordForm: FC<PasswordFormProps> = ({
  isSending,
  onSubmit,
}) => {
  const [form] = useForm<PasswordFormValues>();

  const submit = (values: PasswordFormValues) => {
    if (values.password) {
      onSubmit(values.password);
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={submit}
      className="connect-integration-modal__password-form"
    >
      <Text type="secondary">
        Аккаунт защищён паролем двухэтапной аутентификации. Это последний шаг —
        после него интеграция заработает.
      </Text>
      <Item
        label="Пароль"
        name="password"
        rules={[{ required: true, message: 'Укажите пароль' }]}
      >
        <Input.Password data-testid="connect-auth-password" />
      </Item>
      <Button
        type="primary"
        htmlType="submit"
        loading={isSending}
        data-testid="connect-auth-send-password"
      >
        Подтвердить
      </Button>
    </Form>
  );
};
